import { render, staticRenderFns } from "./form-zone-crud.vue?vue&type=template&id=a3cd60ae&scoped=true"
import script from "./form-zone-crud.vue?vue&type=script&lang=js"
export * from "./form-zone-crud.vue?vue&type=script&lang=js"
import style0 from "./form-zone-crud.vue?vue&type=style&index=0&id=a3cd60ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cd60ae",
  null
  
)

export default component.exports